import service from "@/store/services/cafeterias-service";

export const state = () => ({
  list: {},
  cafeteria: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, cafeteria) => {
    state.cafeteria = cafeteria;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((cafeteria) => {
      commit("SET_RESOURCE", cafeteria);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((cafeteria) => {
      commit("SET_RESOURCE", cafeteria);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((cafeteria) => {
      commit("SET_RESOURCE", cafeteria);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  cafeteria: (state) => state.cafeteria,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((cafeteria) => ({
      id: cafeteria.id,
      name: `${cafeteria.name}`,
    }));
  },
};

const cafeterias = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default cafeterias;
